// extracted by mini-css-extract-plugin
export default {"Container":"planning_Container__Yxvt-","section-1":"planning_section-1__Sj-KJ","content":"planning_content__4CTYa","section-2":"planning_section-2__wDqrJ"};